import {
  SET_ENTITY_TYPE_LIST,
  SET_INVENTORY_STATUS_LIST,
  SET_TRANSACTION_STATUS_LIST,
  SET_DEVICE_STATUS_LIST,
  SET_USER_ROLE_AUTHORITY_LIST,
  SET_ADDRESS_TYPE_LIST,
  SET_COUNTRY_LIST,
} from '../constants/constant_action_types';

export const setEntityTypeList = (payload) => {
  return { type: SET_ENTITY_TYPE_LIST, payload };
};

export const setInventoryStatusList = (payload) => {
  return { type: SET_INVENTORY_STATUS_LIST, payload };
};

export const setTransactionStatusList = (payload) => {
  return { type: SET_TRANSACTION_STATUS_LIST, payload };
};

export const setDeviceStatusList = (payload) => {
  return { type: SET_DEVICE_STATUS_LIST, payload };
};

export const setUserRoleAuthorityList = (payload) => {
  return { type: SET_USER_ROLE_AUTHORITY_LIST, payload };
};

export const setAddressTypeList = (payload) => {
  return { type: SET_ADDRESS_TYPE_LIST, payload };
};

export const setCountryList = (payload) => {
  return { type: SET_COUNTRY_LIST, payload };
};
